
const digest = '07e57a4b7562a83b3d5f262fc49b5bf3f6d677531b96e5dabf8416acd0643d5f';
const classes = {"wrapper":"_wrapper_1ljg5_1","uploadButton":"_uploadButton_1ljg5_1","placeholder":"_placeholder_1ljg5_17","input":"_input_1ljg5_24"};
const css = `._wrapper_1ljg5_1 ._uploadButton_1ljg5_1 {
  font-size: 16px;
  font-weight: 600;
  padding: 25px 20px;
  width: 100%;
  text-align: left;
  position: relative;
  background: #eaf2ff;
  background: linear-gradient(180deg, #eaf2ff 0, #cad9f3 100%);
  color: #3c3f9c;
  border-radius: 15px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
._wrapper_1ljg5_1 ._placeholder_1ljg5_17 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}
._wrapper_1ljg5_1 ._input_1ljg5_24 {
  display: none;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  